import React from "react";
import { AiOutlineVerticalAlignTop } from "react-icons/ai";

const ScrollToTopIcon = ({ handleScrollTop }) => {
  return (
    <div
      onClick={() => {
        handleScrollTop();
      }}
      className="fixed z-[999] cursor-pointer text-3xl bottom-[160px] md:right-[50px] right-[15px] border border-main-color text-main-color flex items-center justify-center rounded-full md:w-[55px] md:h-[55px] w-[44px] h-[44px]"
    >
      <AiOutlineVerticalAlignTop />
    </div>
  );
};

export default ScrollToTopIcon;
